import React, { Fragment } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { RenderWithCondition } from '../../../../components/shared/Conditional/RenderWithCondition';
import { ArrowForwardIos } from '@mui/icons-material';

export const StagesSkeleton = () => (
  <Stack gap="1rem">
    <Stack direction="row" alignContent="center" justifyContent="space-between">
      <Skeleton variant="text" sx={{ width: '200px', height: '36px' }} />

      <Stack direction="row" gap="0.5rem">
        <Skeleton variant="rectangular" sx={{ width: '250px', height: '36px' }} />
        <Skeleton variant="rectangular" sx={{ width: '30px', height: '36px' }} />
      </Stack>
    </Stack>

    <Stack direction="column" gap="0.75rem">
      <Stack direction="row" gap="0.5rem" alignItems="center">
        {new Array(5).fill('').map((_, i, arr) => (
          <Fragment key={i}>
            <Skeleton variant="rectangular" sx={{ width: '120px', height: '32px' }} />

            <RenderWithCondition condition={i !== arr.length - 1}>
              <ArrowForwardIos sx={{ fontSize: '1rem' }} />
            </RenderWithCondition>
          </Fragment>
        ))}
      </Stack>

      <Stack direction="row" justifyContent="space-between">
        <Skeleton variant="text" sx={{ width: '249px', height: '40px' }} />
        <Skeleton variant="rectangular" sx={{ width: '300px', height: '40px' }} />
      </Stack>
    </Stack>
  </Stack>
);
